import { render, staticRenderFns } from "./frontendapp.vue?vue&type=template&id=61329772&"
import script from "./frontendapp.vue?vue&type=script&lang=js&"
export * from "./frontendapp.vue?vue&type=script&lang=js&"
import style0 from "./frontendapp.vue?vue&type=style&index=0&id=61329772&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports